/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2023. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Main } from '@govhhs/govhhs-design-system-react';
import {
  ScrollToTop,
  SessionTimeout,
  ErrorBoundary,
  SSOVerifier,
  Toaster,
  ConnectivityHandler,
} from '@spm/universal-access-ui';
import { IEGRegistry } from '@spm/core';
import { ApplicationHeader, ApplicationHeaderComponent } from './features/ApplicationHeader';
import routes from './routes';
import ReduxInit from './redux/ReduxInit';
import IntlInit from './intl/IntlInit';
import ApplicationFooter from './features/ApplicationFooter';
import 
  { searchProvider }
 // eslint-disable-next-line import/no-unresolved, import/extensions
 from './utils/ProviderSearch/ACESProviderSearchUtils';
/**
 * App component entry point.
 */
const App = () => {

  IEGRegistry.registerComboBoxSearchFunctions({
    getACESBuralHomeList: searchProvider,
    searchProvider
  });
return(
  <ReduxInit>
    <IntlInit>
      <Router basename={process.env.PUBLIC_URL}>
        <ScrollToTop>
          <ErrorBoundary
            footer={<ApplicationFooter />}
            header={<ApplicationHeaderComponent hasErrorBeenCaught />}
            isHeaderBoundary
          >
            <ConnectivityHandler>
              <SSOVerifier
                placeholder={
                  <ApplicationHeaderComponent
                    isALinkedUser={() => false}
                    isAppealsEnabled={false}
                    isEmpty
                  />
                }
              >
                <ApplicationHeader />
                <ErrorBoundary>
                  <SessionTimeout />
                  <Toaster />
                  <Main
                    className="wds-u-bg--page wds-u-text-word-break"
                    id="maincontent"
                    pushFooter
                  >
                    {routes}
                  </Main>
                </ErrorBoundary>
                <ApplicationFooter />
              </SSOVerifier>
            </ConnectivityHandler>
          </ErrorBoundary>
        </ScrollToTop>
      </Router>
    </IntlInit>
  </ReduxInit>
);
};
export default App;
